<template>
  <div>
    <p class="title-text">請使用Lala app 掃描QR Code登入</p>
    <div class="flex justify-center align-center">
      <div class="text-center">
        <div class="qrcode-expired-mask text-center" v-show="invalid">
          <div class="QRpscenter">
            <svg class="cursor-pointer qrCodeMask" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" @click="refreshQRCode">
              <g filter="url(#filter0_d)">
                <circle cx="24" cy="24" r="20" fill="white" />
                <path
                  d="M30.2774 17.7237C28.4663 15.9126 25.8996 14.8682 23.0774 15.1571C18.9996 15.5682 15.6441 18.8793 15.1885 22.9571C14.5774 28.346 18.7441 32.8904 23.9996 32.8904C27.5441 32.8904 30.5885 30.8126 32.0107 27.8237C32.3663 27.0793 31.833 26.2237 31.0107 26.2237C30.5996 26.2237 30.2108 26.446 30.033 26.8126C28.7774 29.5126 25.7663 31.2237 22.4774 30.4904C20.0108 29.946 18.0219 27.9348 17.4996 25.4682C16.5663 21.1571 19.8441 17.3348 23.9996 17.3348C25.8441 17.3348 27.4885 18.1015 28.6885 19.3126L27.0108 20.9904C26.3108 21.6904 26.7996 22.8904 27.7885 22.8904H31.7774C32.3885 22.8904 32.8885 22.3904 32.8885 21.7793V17.7904C32.8885 16.8015 31.6885 16.3015 30.9885 17.0015L30.2774 17.7237Z"
                  fill="#3BB4B7"
                />
              </g>
              <defs>
                <filter id="filter0_d" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
              </defs>
            </svg>
            行動條碼使用效期已過期
            <br />
            請更新
          </div>
        </div>
        <qrcode :value="qrCodeURL" :options="{ width: 250 }"></qrcode>
      </div>
    </div>
    <div class="text-center text-primary">
      <div class="text-center">
        <div class=""><hr /></div>
        <div class="flex p-30">
          <div class="footer-text">
            <p>請先使用Lale App登入平台並完成綁定，方可使用Lale App掃描 QR Code登入。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { uid } from 'quasar';
import { mapActions, mapMutations, mapState } from 'vuex';
import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);
// const qrCodeUrlPrefix = `${process.env.VUE_APP_LALE_PATH}/customers/lale/app/login?uuid=`;
// https://lalepass.lale.im 自己開發環境要掃碼時打開此，並換成用 ip 啟動環境
const qrCodeUrlPrefix = 'https://lalepass.lale.im/customers/lale/app/login?uuid=';
const qrCodeUrlSuffix = '&token=$token';
export default {
  name: 'LaleQRcode',
  data: function() {
    return {
      loading: true,
      invalid: false,
      qrCodeURL: '',
      timer: null,
      uuid: ''
    };
  },
  computed: {
    ...mapState(['token'])
  },
  methods: {
    ...mapActions(['qrCodeLoginValid']),
    refreshQRCode: function() {
      this.loading = true;
      this.uuid = uid();
      // this.qrCodeURL = qrCodeUrlPrefix + this.uuid + qrCodeUrlSuffix;
      this.qrCodeURL = JSON.stringify({"key":"qrLogin","uuid": this.uuid});
      this.invalid = false;
      this.loading = false;
    },
    startValidTimer: function() {
      const uuid = this.uuid;
      let count = 0;
      this.timer = setInterval(() => {
        // 有 token 後就結束計時
        if (this.token) {
          this.stopValidTimer();
          return;
        }
        count++;
        // 每 5 秒更新一次，中間總共會在背景輪詢 12 次，也就是此 QRCode 60 秒過期，過期後需要更新 QRCode
        if (count > 12) {
          this.stopValidTimer();
          this.invalid = true;
          this.qrCodeURL = 'invalid';
        }
        this.qrCodeLoginValid({ uuid });
      }, 5000);
    },
    stopValidTimer: function() {
      if (this.timer !== null) clearInterval(this.timer);
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.refreshQRCode();
    });
  },
  watch: {
    uuid: function() {
      this.stopValidTimer();
      this.startValidTimer();
    }
  },
  created() {
    this.refreshQRCode();
  }
};
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}
.p-30 {
  padding: 10px 10px 30px 10px;
}
.title-text {
  padding: 10px;
  color: #56bc94;
  font-size: 16px;
}

.footer-text {
  background-color: #fcf8e3;
  border: 1px solid #fcf5e5;
  color: #c0af8b;
}

.qrCodeMask {
  display: block;
  margin: 0 auto;
}

.QRpscenter {
  position: absolute;
  z-index: 999999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.qrcode-expired-mask {
  width: 250px;
  height: 250px;
  background-color: #fff;
  opacity: 0.9;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
